module.exports = __webpack_public_path__ + "img/live-mic.6fa38efe.svg";